import { render, staticRenderFns } from "./hazardRectification.vue?vue&type=template&id=2a620462&scoped=true"
import script from "./hazardRectification.vue?vue&type=script&lang=js"
export * from "./hazardRectification.vue?vue&type=script&lang=js"
import style0 from "./hazardRectification.vue?vue&type=style&index=0&id=2a620462&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a620462",
  null
  
)

export default component.exports